(function () {
  'use strict';

  /* ---------------- Toast ---------------- */
  function toast(msg) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }

  /* ---------------- Mobile nav ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---------------- Search bar ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) {
      var bar = document.querySelector('[data-search-bar]');
      if (bar) {
        bar.hidden = !bar.hidden;
        if (!bar.hidden) {
          var input = bar.querySelector('input[type="search"]');
          if (input) input.focus();
        } else {
          var results = bar.querySelector('[data-predictive-results]');
          if (results) results.hidden = true;
        }
      }
    }
  });

  /* ---------------- Slider ---------------- */
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var slides = slider.querySelectorAll('.slide');
    var dots = slider.querySelectorAll('[data-slider-dot]');
    var index = 0;
    var timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }
    function restart() {
      clearInterval(timer);
      if (slider.dataset.autoplay === 'true' && slides.length > 1) {
        timer = setInterval(next, parseInt(slider.dataset.interval, 10) || 6000);
      }
    }

    slider.querySelectorAll('[data-slider-next]').forEach(function (b) { b.addEventListener('click', function () { next(); restart(); }); });
    slider.querySelectorAll('[data-slider-prev]').forEach(function (b) { b.addEventListener('click', function () { prev(); restart(); }); });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); restart(); }); });

    if (slides.length) { go(0); restart(); }
  });

  /* ---------------- Grid column toggle ---------------- */
  document.querySelectorAll('[data-grid-toggle]').forEach(function (group) {
    var targetSelector = group.getAttribute('data-grid-toggle');
    group.querySelectorAll('.grid-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.grid-toggle').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        document.querySelectorAll(targetSelector).forEach(function (grid) {
          grid.setAttribute('data-cols', btn.dataset.cols);
        });
      });
    });
  });

  /* ---------------- Product gallery thumbs ---------------- */
  document.querySelectorAll('.pd-gallery').forEach(function (gallery) {
    var main = gallery.querySelector('[data-pd-main]');
    gallery.querySelectorAll('[data-pd-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-pd-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.style.backgroundImage = thumb.style.backgroundImage;
      });
    });
  });

  /* ---------------- Quantity steppers (generic) ---------------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    val = plus ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Wishlist (browser-local only) ---------------- */
  var WISHLIST_KEY = 'hairngo:wishlist';
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function updateWishlistBadge() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  function syncWishlistButtons() {
    var ids = readWishlist().map(function (i) { return String(i.id); });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', ids.indexOf(String(btn.dataset.id)) !== -1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var id = btn.dataset.id;
    var title = btn.dataset.title || 'Item';
    var list = readWishlist();
    var idx = list.findIndex(function (i) { return String(i.id) === String(id); });
    if (idx > -1) {
      list.splice(idx, 1);
      toast(title + ' removed from wishlist');
    } else {
      list.push({ id: id, title: title });
      toast(title + ' added to wishlist');
    }
    writeWishlist(list);
    updateWishlistBadge();
    syncWishlistButtons();
  });
  updateWishlistBadge();
  syncWishlistButtons();

  /* ---------------- Cart drawer open/close (delegated so it survives re-renders) ---------------- */
  function openDrawer() {
    var overlay = document.querySelector('[data-cart-overlay]');
    var drawer = document.querySelector('[data-cart-drawer]');
    if (overlay) overlay.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
  }
  function closeDrawer() {
    var overlay = document.querySelector('[data-cart-overlay]');
    var drawer = document.querySelector('[data-cart-drawer]');
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { openDrawer(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { closeDrawer(); }
  });

  /* ---------------- Ajax Cart API ---------------- */
  var CART_SECTIONS = 'cart-drawer';

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  function swapSection(sectionId, html) {
    var wrapperId = 'shopify-section-' + sectionId;
    var wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var next = temp.firstElementChild;
    if (next) wrapper.replaceWith(next);
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  function handleCartResponse(data) {
    if (data.sections && data.sections[CART_SECTIONS]) {
      swapSection(CART_SECTIONS, data.sections[CART_SECTIONS]);
    }
    refreshCartCount();
    openDrawer();
  }

  function addToCart(variantId, quantity, title) {
    if (!variantId) { toast('Please select an option first'); return; }
    cartRequest('/cart/add.js', {
      items: [{ id: variantId, quantity: quantity || 1 }],
      sections: CART_SECTIONS
    }).then(function (data) {
      handleCartResponse(data);
      toast((title || 'Item') + ' added to bag');
    }).catch(function (err) {
      toast((err && err.description) || 'Couldn\u2019t add that to your bag');
    });
  }

  // Simple product-card / quick add buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.hasAttribute('disabled')) return;
    e.preventDefault();
    addToCart(btn.dataset.variantId, 1, btn.dataset.title);
  });

  // Full product-form submit (with quantity + variant select)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var titleEl = document.querySelector('.pd-title');
    addToCart(idInput ? idInput.value : null, qtyInput ? parseInt(qtyInput.value, 10) : 1, titleEl ? titleEl.textContent : null);
  });

  // Line quantity +/- and remove inside the drawer (delegated)
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cart-qty-minus]');
    var plus = e.target.closest('[data-cart-qty-plus]');
    var remove = e.target.closest('[data-cart-remove]');
    if (!minus && !plus && !remove) return;
    e.preventDefault();
    var line = (minus || plus || remove).dataset.line;
    var lineEl = document.querySelector('[data-cart-line][data-line="' + line + '"]');
    var qtyEl = lineEl && lineEl.querySelector('[data-qty] span');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var next = remove ? 0 : (plus ? current + 1 : Math.max(0, current - 1));

    cartRequest('/cart/change.js', { line: parseInt(line, 10), quantity: next, sections: CART_SECTIONS })
      .then(handleCartResponse)
      .catch(function () { toast('Couldn\u2019t update your bag'); });
  });

  refreshCartCount();

  /* ---------------- Variant selection on product page ---------------- */
  document.querySelectorAll('[data-product-json]').forEach(function (wrap) {
    var product;
    try { product = JSON.parse(wrap.getAttribute('data-product-json')); } catch (e) { return; }
    var form = wrap.querySelector('[data-product-form]');
    if (!form || !product) return;
    var select = form.querySelector('[data-variant-select]');
    var priceEl = wrap.querySelector('[data-product-price]');
    var stockEl = wrap.querySelector('[data-product-stock]');
    var submitBtn = form.querySelector('[data-add-to-cart-form]');
    var mainImg = wrap.querySelector('[data-pd-main]');

    var selected = {};
    product.options.forEach(function (name, i) {
      var current = product.variants[0] && product.variants[0].options[i];
      selected[i] = current;
    });

    function findVariant() {
      return product.variants.find(function (v) {
        return product.options.every(function (name, i) { return v.options[i] === selected[i]; });
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function render() {
      var variant = findVariant();
      if (!variant) return;
      if (select) select.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<s>' + money(variant.compare_at_price) + '</s>' + money(variant.price);
        } else {
          priceEl.textContent = money(variant.price);
        }
      }
      if (stockEl) {
        stockEl.innerHTML = variant.available ? '&#9679; In stock \u2014 ships in 24 hours' : '&#9679; Sold out';
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (mainImg && variant.featured_image) {
        mainImg.style.backgroundImage = 'url(' + variant.featured_image.src + ')';
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var i = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('[data-option-value]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          group.querySelectorAll('[data-option-value]').forEach(function (s) { s.classList.remove('is-selected'); });
          swatch.classList.add('is-selected');
          selected[i] = swatch.dataset.optionValue;
          render();
        });
      });
    });

    render();
  });

  /* ---------------- Predictive search ---------------- */
  (function () {
    var form = document.querySelector('[data-predictive-search]');
    var input = document.querySelector('[data-predictive-search-input]');
    var results = document.querySelector('[data-predictive-results]');
    if (!form || !input || !results) return;

    var debounceTimer = null;
    var currentTerm = '';

    function escapeHtml(str) {
      return (str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function render(term, products) {
      if (!products.length) {
        results.innerHTML = '<div class="predictive-results__empty">No products found for \u201c' + escapeHtml(term) + '\u201d</div>';
        results.hidden = false;
        return;
      }
      var html = products.map(function (p) {
        var priceHtml = p.price;
        if (p.compare_at_price_max && p.price_max && p.compare_at_price_max > p.price_max) {
          priceHtml = '<s>' + p.compare_at_price + '</s>' + p.price;
        }
        return '<a class="predictive-results__item" href="' + p.url + '">' +
          '<div class="predictive-results__media" style="background-image:url(\'' + (p.image || '') + '\');"></div>' +
          '<div><p class="predictive-results__title">' + escapeHtml(p.title) + '</p>' +
          '<p class="predictive-results__price">' + priceHtml + '</p></div>' +
          '</a>';
      }).join('');
      html += '<a class="predictive-results__viewall" href="' + form.action + '?q=' + encodeURIComponent(term) + '&type=product">See all results for \u201c' + escapeHtml(term) + '\u201d</a>';
      results.innerHTML = html;
      results.hidden = false;
    }

    function search(term) {
      currentTerm = term;
      if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (term !== currentTerm) return; // stale response
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(term, products);
        })
        .catch(function () { results.hidden = true; });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var term = input.value.trim();
      debounceTimer = setTimeout(function () { search(term); }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search-bar]')) { results.hidden = true; }
    });
    input.addEventListener('focus', function () {
      if (results.innerHTML && input.value.trim().length >= 2) results.hidden = false;
    });
  })();

  /* ---------------- Account: login/recover toggle + new-address toggle ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toggle-recover]')) {
      var login = document.getElementById('login-form');
      var recover = document.getElementById('recover-form');
      if (login && recover) {
        login.classList.toggle('is-hidden');
        recover.classList.toggle('is-hidden');
      }
    }
    if (e.target.closest('[data-toggle-new-address]')) {
      var form = document.getElementById('new-address-form');
      if (form) form.classList.toggle('is-hidden');
    }
  });

  /* ---------------- Newsletter success toast (in case of redirect back) ---------------- */
  if (document.querySelector('.newsletter__success')) {
    toast('Thanks for subscribing!');
  }
})();
